"use client"
import { useState, useEffect } from "react";
import { useParams } from "next/navigation";


import { getCookies } from "@/utils/frontend/cookieOps";

import { GrayButton, IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons";
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";

const SupportModal = ({
  lang,
  callback,
  components,
  state,
  modalHeaderCaption,
  user
}) => {

  const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned } = useContext(UIContext);


  // const user = getCookies().user

  // const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState() // new data
  const [postData, setPostData] = useState({})
  const [bulletinsTableArray, setBulletinsTableArray] = useState([])

  const [apiTags, setApiTags] = useState()
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showErrorAlert, setShowErrorAlert] = useState(false)
  const [tagsTableArray, setTagsTableArray] = useState()
  const [tagEditorModalOpen, setTagEditorModalOpen] = useState(false)
  const [targetTag, setTargetTag] = useState()
  const [tagColors, setTagColors] = useState()
  const [existingTags, setExistingTags] = useState([])
  const [tagDeleteModalOpen, setTagDeleteModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  // const [bulletinContent, setBulletinContent] = useState(null)



  // const getData = async () => {
  //   try {
       
  //     // let apiUrl = target ? `/api/jobs/?id=${target.id}` : `/api/jobs/`
  //     let apiUrl = `/api/bulletins/`
  //     let response = await fetch(apiUrl, {
  //     //  method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
  //     method: 'GET',
  //      headers: {
  //        'Accept': '*/*',
  //        'Content-Type': 'application/json'
  //      },
  //      credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
     
  //     // body: data
  //    });

  //    response = await response.json()
  //   //  console.log(response)
  //    let bulletins = response.data;
  //    setBulletinsTableArray(bulletins.reverse())
  //    let existingTagsArray = []
  //   //   tags.forEach(tag => {
  //   //      let obj = {id: tag.id, value: tag.tag_name, label: tag.tag_name, tag_type: tag.tag_type}
  //   //      // array.push(obj)
  //   //      existingTagsArray.push(tag.tag_name)
  //   // });
  //   setLoading(false)
  //   setExistingTags(existingTagsArray);
        
  //   } catch (error) {
  //     console.log('error', error)
  //     // setError(error)
  //     setExistingTags([]);
  //   }


  // }
  
  useEffect(() => {
    setPostData({...postData, source_url: window.location.href})
  // getData()
  }, [])


  const handleClick = async (tag, action) => {
    console.log(tag)
    if (action === 'edit') { 
      setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
      setTagEditorModalOpen(true)
    }
    else if (action === 'delete') {
      setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
      setTagDeleteModalOpen(true)

    }
  }


  // const navigate = useNavigate();
  const { id } = useParams(); // get person / job / company ID based on current page id where component is called





  const handleSubmit = async () => {
    setLoading(true)
    if (!postData.email_body || postData.email_body.length < 10) {
      state.setError({message: lang === 'fr' ? 'Votre message est trop court.' : 'Your message is too short.'})
      setLoading(false)
      return false;
    }
      try { 
        let apiUrl = `/api/services/emails`
        let response = await fetch(apiUrl, {   
        method: 'POST',
         headers: {
           'Accept': '*/*',
           'Content-Type': 'application/json'
         },
         credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
         body: JSON.stringify({data: postData, user: user}), // Convert the credentials object to a JSON string
       });

       response = await response.json()
       console.log(response)
       setPostData({...postData, email_body: ''})
       setLoading(false)
       state.setSupportModalOpen(false)
       state.setSuccess({message: lang === 'fr' ? "Votre requête à été envoyée" : 'Your request has been sent'})
      } catch (error) {
        console.log('error', error)
        state.setError({message: lang === 'fr' ? "Votre requête n'a pas pu être envoyée" : `Your request could not be sent\n${error}`})
        setLoading(false)
      }


  };



  // const handleChildCallback =  (callback)=>{
  //   console.log('cb', callback)
    
  //   if (callback.tags !== undefined){
  //     const tagsData = callback.tags.map(obj=>({tag_name: obj.value, tag_type: "PRIMARY"}))
  //     setData(tagsData)
  //   }

  //   if (callback.error) { setError(callback.error) }
  //   if (callback.success) { setSuccess(callback.success) }

  //   // if (callback.allTags) {setTagList(callback.allTags.reverse());}
  //   // if (callback.tagEditorModalOpen === false){setTagEditorModalOpen(false)}

  //   if (callback.tagColors && callback.tagColors.id) {setTagColors({colors: callback.tagColors.colors, id:callback.tagColors.id})}
  //   if (callback.refreshTable===true){setTimeout(() => {getData() }, 50);}
  //   if (callback.tagDeleteModalOpen === false) {setTagDeleteModalOpen(false); }

  // }

  // const handleCheckBox = (checked, target) => {
  //   console.log('checked, target', checked, target)
  //   setData({...data, bulletin_target_pages: {...data?.bulletin_target_pages, [target]: checked}})
  //   console.log(data)
  // }

  return (
<>





<div className="">
     {/* slide from bottom up */}
{/* <div
  className={`fixed min-h-96 text-sm rounded-xl shadow-2xl z-20 ${sideNavbarPinned ? 'left-64' : 'left-24'} w-4/5 md:w-4/6 lg:w-2/6 p-4 bg-gray-50 font-medium dark:bg-slate-900 border-gray-300 dark:border-gray-700 text-black dark:text-white transition-all duration-300 transform ${state.supportModalOpen ? 'translate-y-0 bottom-3' : 'translate-y-full bottom-0'}`}
> */}
     {/* slide from right to left */}
  <div
  // h-[calc(100vh-76px)]
  className={`p-4 flex flex-col justify-between overflow-y-scroll no-scrollbar fixed min-h-96 h-full text-sm border-l border-l-slate-200 z-50 right-0 w-4/5 md:w-4/6 lg:w-2/6 bg-slate-50 dark:bg-slate-900 border-gray-300 dark:border-gray-700 text-black dark:text-white transition-all duration-300 transform ${state.supportModalOpen ? 'translate-x-0 bottom-0' : 'translate-x-full bottom-0'}`}
>

  <div className="flex items-center">
    {/* Close Button on the Left */}
    <button
      onClick={() => {
        state.setSupportModalOpen(false);
      }}
      type="button"
      className="transition duration-300 ease-in-out mr-4 bg-gray-100 hover:bg-gray-200 text-gray-500 dark:text-gray-400 focus:ring-gray-400 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700"
      aria-label="Close"
    >
      <span className="sr-only">Close</span>
      <svg
        className="w-3 h-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
    </button>

    {/* Text on the Right */}
    <div className="text-gray-600 dark:text-gray-200">
      {lang === "fr" ? (
        <>
          <i className="fa-solid fa-comment"></i> Demandez du Support, une
          Fonctionnalité, ou reportez un Bug.
        </>
      ) : (
        <>
          <i className="fa-solid fa-comment"></i> Get Support, Request a
          Feature, or Report a Bug
        </>
      )}
    </div>
  </div>

{/*=================== 
---TEXTAREA 
====================*/}
  <div className="my-4">
    <textarea
      rows="18"
      className="w-full dark:bg-inherit mb-4 appearance-none border border-gray-200 dark:border-gray-600 rounded-lg py-3 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm text-black dark:text-white"
      id="organization_about"
      value={postData?.email_body}
      onChange={(x) => {
        setPostData({ ...postData, email_body: x.target.value });
      }}
      name="support_message"
      placeholder={
        lang === "fr"
          ? `Comment peut-on vous aider ?`
          : `How may we help you?`
      }
    />
  </div>

  <div className="justify-end text-right space-x-2 flex items-center">
    <GrayButton
      caption={
        lang === "fr" ? (
          "Annuler"
        ) : (
          <>Cancel</>
        )
      }
      onClick={() => {
        setPostData({ ...postData, email_body: "" });
        state.setSupportModalOpen(false);
        setLoading(false);
      }}
    />
    <div className="w-24">
      <TealButton
        loading={loading}
        caption={
          lang === "fr" ? (
            <>
              <i className="fa-solid fa-paper-plane mr-1" /> Envoyer
            </>
          ) : (
            <>
              <i className="fa-solid fa-paper-plane mr-1" /> Send
            </>
          )
        }
        onClick={() => {
          handleSubmit();
        }}
      />
    </div>
  </div>
</div>
   </div>



{/* <div className="">
     
     <div
       className={`fixed min-h-96 text-sm rounded-xl shadow-2xl z-50 left-24 w-4/5 md:w-4/6 lg:w-2/6 p-4 bg-gray-50 font-medium dark:bg-gray-900 border-gray-300 dark:border-gray-700 text-black dark:text-white transition-transform duration-300 transform ${state.supportModalOpen ? 'translate-y-0 bottom-3' : 'translate-y-full bottom-0'} `}
     >



       <div className="flex justify-between items-center">
         <div className="text-gray-600 dark:text-gray-200">
      
          {lang === 'fr' ? <><i className="fa-solid fa-comment"></i> Demandez du Support, une Fonctionnalité, ou reportez un Bug.</> : <><i className="fa-solid fa-comment"></i> Get Support, Request a Feature, or Report a Bug</>}
          </div>


      <button onClick={()=>{state.setSupportModalOpen(false)}} type="button" className={`transition duration-300 ease-in-out ml-auto -mx-1.5 -my-1.5 bg-gray-100 hover:bg-gray-200 text-gray-500 dark:text-gray-400 focus:ring-gray-400 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700`} data-dismiss-target="#alert-2" aria-label="Close">
          <span className="sr-only">Close</span>
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>

       </div>
       <div className="my-4">
       <textarea
                rows="18"
                className="w-full dark:bg-inherit mb-4 appearance-none border border-gray-200 dark:border-gray-600 rounded-lg py-3 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm text-black dark:text-white"
                id="organization_about"
                value={postData?.email_body}
                onChange={(x)=>{setPostData({...postData, email_body: x.target.value})}}
                name="support_message"
                placeholder={lang === 'fr' ? `Comment peut-on vous aider ?` : `How may we help you?`}
              />
              </div>
              <div className="justify-end text-right space-x-2 flex items-center">
                <GrayButton caption={lang === 'fr' ? 'Annuler' : <>Cancel</>} onClick={()=>{setPostData({...postData, email_body: ''}); state.setSupportModalOpen(false); setLoading(false)}}/>
                <div className="w-24">
                <TealButton loading={loading} caption={lang === 'fr' ? <><i className="fa-solid fa-paper-plane mr-1"/> Envoyer</>  : <><i className="fa-solid fa-paper-plane mr-1"/> Send</>} onClick={()=>{handleSubmit()}}/>
                </div>
              </div>
     </div>
   </div> */}
</>

   
  );
};

export default SupportModal;





// "use client" 
// import { useEffect, useState} from "react";

// import { useParams } from "next/navigation";
// import { humanizeString } from "@/utils/frontend/stringOps.js";
// import ModalOverlay from "../../Atoms/ModalOverlay.js";
// import ModalHeader from "./ModalHeader.js";
// import ModalFooter from "./ModalFooter.js";
// import Loading from "@/components/Atoms/Alerts/Loading";
// import TagsCreatableSelect from "../../Atoms/Select/TagsCreatableSelect";
// import TagEditorModal from "./TagEditorModal";
// import TagDeleteModal from "./TagDeleteModal";
// import TagsTable from "../TagsTable";
// import Alert from "@/components/Atoms/Alerts/Alert";
// import { getCookies } from "@/utils/frontend/cookieOps";
// import RadioButton from "../../Atoms/Buttons/RadioButton.js";
// import FormSubHeading from "../../Atoms/FormElements/FormSubHeading.js";
// import RadioButton_1 from "../../Atoms/Buttons/RadioButton_1.js";
// import LocationSelect from "../../Atoms/Select/LocationSelect.js";

// import InputText from "@/components/Atoms/inputText.js";
// import TextEditor from "../TextEditor.js";



// const TagsModal =  ({
//   state,
//   components,
//   callback,
//   target,
//   modalHeaderCaption
// }) => {

// const user = getCookies().user

//   const [data, setData] = useState() // new data
//   const [error, setError] = useState(false)
//   const [success, setSuccess] = useState(false)
//   const [showSuccessAlert, setShowSuccessAlert] = useState(false)
//   const [showErrorAlert, setShowErrorAlert] = useState(false)
//   const [tagList, setTagList] = useState()
//   const [tagEditorModalOpen, setTagEditorModalOpen] = useState(false)
//   const [targetTag, setTargetTag] = useState()
//   const [tagColors, setTagColors] = useState()
//   const [existingTags, setExistingTags] = useState([])
//   const [tagDeleteModalOpen, setTagDeleteModalOpen] = useState(false)
//   const [loading, setLoading] = useState(true)


  




//   const getData = async () => {


//     try {
       
//       // let apiUrl = target ? `/api/jobs/?id=${target.id}` : `/api/jobs/`
//       let apiUrl = `/api/tags/`
//       let response = await fetch(apiUrl, {
//       //  method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
//       method: 'GET',
//        headers: {
//          'Accept': '*/*',
//          'Content-Type': 'application/json'
//        },
//        credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
     
//       // body: data
//      });

//      response = await response.json()
//      console.log(response)
//      let tags = response.data;
//      setTagList(tags.reverse())
//      let tagsArray = []
//       tags.forEach(tag => {
//          let obj = {id: tag.id, value: tag.tag_name, label: tag.tag_name, tag_type: tag.tag_type}
//          // array.push(obj)
//          tagsArray.push(tag.tag_name)
//     });
//     setLoading(false)
//     setExistingTags(tagsArray);
        
//     } catch (error) {
//       console.log('error', error)
//       // setError(error)
//       setExistingTags([]);
//     }


//     // try {

//     // const response = await axios.get(`/tags/`);
//     // let data = response.data;
    
//     // setTagList(data.reverse())

//     // // populate tagsArray with tag names to check for duplicates later
//     // let tagsArray = []
//     // data.forEach(tag => {
//     //      let obj = {id: tag.id, value: tag.tag_name, label: tag.tag_name, tag_type: tag.tag_type}
//     //      // array.push(obj)
//     //      tagsArray.push(tag.tag_name)

//     // });

//     // setExistingTags(tagsArray);
//     // return data
//     // } catch(error) {
//     // setError(error.message);
//     // // setExistingTags(null);
//     // setExistingTags([]);
//     // } finally {
//     // setLoading(false);
//     // }  
//   }

//   useEffect(() => {

//   getData()
//   }, [])


//     const handleClick = async (tag, action) => {
//     console.log(tag)
//     if (action === 'edit') { 
//       setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
//       setTagEditorModalOpen(true)
//     }
//     else if (action === 'delete') {
//       setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
//       setTagDeleteModalOpen(true)

//     }
//   }








//   const handleChildCallback =  (callback)=>{
//     console.log('cb', callback)
    
//     if (callback.tags !== undefined){
//       const tagsData = callback.tags.map(obj=>({tag_name: obj.value, tag_type: "PRIMARY"}))
//       setData(tagsData)
//     }

//     if (callback.error) { setShowErrorAlert(true); setError(callback.error) }
//     if (callback.showErrorAlert === false) { setShowErrorAlert(false) }
//     if (callback.showSuccessAlert === false) { setShowSuccessAlert(false) }
//     // if (callback.allTags) {setTagList(callback.allTags.reverse());}
//     // if (callback.tagEditorModalOpen === false){setTagEditorModalOpen(false)}

//     if (callback.tagColors && callback.tagColors.id) {setTagColors({colors: callback.tagColors.colors, id:callback.tagColors.id})}
//     if (callback.refreshTable===true){setTimeout(() => {getData() }, 50);}
//     if (callback.tagDeleteModalOpen === false) {setTagDeleteModalOpen(false); }

//   }

//   const handleRadioButtonCallback = cb => {
//     console.log('callback@JobModal', cb)
//     // callback({action: "presetFilterApplied", presetFilterQuery: cb})
//   }


  
//   const { id } = useParams(); // get person / job / company ID based on current page id where component is called

//   const handleChange = (event) => {
//     setData({
//       ...data,
//       [event.target?.name]: event.target?.value,
//     });
//     console.log(data);
//   };


  

// const putData = {
//   id: target?.id,
//   job_title_en: data?.job_title_en || target?.job_title.en,
//   job_title_fr: data?.job_title_fr || target?.job_title.fr,
//   job_description_en: data?.job_description_en || target?.job_description.en,
//   job_description_fr: data?.job_description_fr || target?.job_description.fr,
//   job_type: data?.job_type || target?.job_type,
//   job_salary: data?.job_salary || target?.job_salary,
//   job_location: data?.job_location || target?.job_location,
//   job_status: data?.job_status || target?.job_status,
//   job_is_published: data?.job_is_published || target?.job_is_published,
// }

// const handleSubmit = async () => {
//   console.log(data)

//   // data?.forEach(async (object)=>{
//     try {
     
//       // let apiUrl = target ? `/api/jobs/?id=${target.id}` : `/api/jobs/`
//       let apiUrl = `/api/tags/`
//       let response = await fetch(apiUrl, {
//       //  method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
//       method: 'POST',
//        headers: {
//          'Accept': '*/*',
//          'Content-Type': 'application/json'
//        },
//        credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
//        body: JSON.stringify({data: data, user: user}), // Convert the credentials object to a JSON string
//       // body: data
//      });

//      response = await response.json()
//      console.log(response)
        
//     } catch (error) {
//       console.log('error', error)
//     }

//     // try {
//     //   const response = await axios.post('/tags/', object, {
//     //     headers: {
//     //       'Accept':'application/json',
//     //       'Content-Type':'application/json',
//     //     }
//     //   })
//     //   console.log(response)
//     //   setSuccess(response)
//     //   setShowSuccessAlert(true)
//     //   getData() // refresh the data in table
//     //   // window.location.reload(true);
//     // } catch (error) {
//     //   console.log(error)
//     //   setError(error)
//     // }
//   // })

// };


//   return (
//     <>

// <div
//   className={`right-0 top-0 overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none mt-0 duration-300 ease-in-out transition-transform transform ${
//     state.bulletinModalOpen === true ? 'translate-x-0' : 'translate-x-full'
//   }`}
// >
//             <div>
//               {/* <div className="fixed top-0 right-0 h-screen w-full z-80 bg-white shadow-lg transform translate-x-full"> */}

//               <div className="mt-0 absolute right-0 top-0 min-h-screen w-5/6 2xl:w-3/4 xl:w-3/4 lg:w-3/4 md:w-3/4 sm:w-4/6">
//                 {/*content*/}
//                 <div className="border-0 rounded-l-3xl min-h-screen shadow-none relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900">
//                   {/*header*/}

//                   <ModalHeader caption={modalHeaderCaption} closeOnClickMethod={() => state.setTagsModalOpen(false)}/>





  
// <span>
// {loading && <Loading/>}
// {error && <Alert state={error} callback={handleChildCallback}/>}
// {success && <Alert state={success} callback={handleChildCallback} message={`Tag(s) Created!`}/>}
// </span>
               

//                   <div className="relative p-6 flex-auto text-left">
//                     <div className="my-4 text-slate-500 text-lg leading-relaxed text-gray-900 dark:text-gray-100">

//                     <FormSubHeading data={'Create New Tags'}/>

//                     <div className="flex grid grid-cols-4 gap-2 mt-2">
//                       {/* Search Field */}
//                       <div className="col-span-3">
//                         <div className="flex items-center">

//                           <div className="relative w-full">
                            

//                             <TagsCreatableSelect callback={handleChildCallback}/>

//                           </div>
//                         </div>
//                       </div>

               

//                     {/* Submit Button */}
//                       <div className="col-span-1">
//                       <div className="relative w-full">
//                       <button className="w-full border border-indigo-600 hover:border-indigo-700 transition duration-300 ease-in-out bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-bold rounded p-2 overflow-hidden" onClick={()=>{handleSubmit()}}>Create</button>

//                       </div>
                    
//                       </div>
                      
//                     </div>


//                     </div>
//                   </div>

//                   {/*footer*/}
//                   <ModalFooter closeOnClickMethod={() => state.setTagsModalOpen(false)} saveOnClickMethod={handleSubmit} 
//                   state={{error: state.error, setError: state.setError, success:state.success, setSuccess: state.setSuccess}}
//                   />

//                 </div>
//               </div>
//             </div>
//           </div>

//           {state.bulletinModalOpen && <ModalOverlay/>}
//         </>

//   );
// };

// export default TagsModal;
